import { ContentBlock, ContentBlockType, MarkdownBlock } from '../../model';
import { ContentBlockTocItem } from './content-block-toc.model';

export const HEADING_REGEX = /^(#{1,6})\s+(.+)$/gm;
export const TOC_ID_DATA_ATTR = 'data-toc-id';

/** Strip `{{icon:...}}`, `{{color:...}}`, and `{{/color}}` tokens from heading text. */
function stripInlineTokens(text: string): string {
  return text.replace(/\{\{(?:icon|color|\/color)[^}]*\}\}/g, '').trim();
}

export function generateHeadingId(blockId: string, headingIndex: number): string {
  return `${blockId}-h${headingIndex}`;
}

function extractHeadingsFromMarkdownBlock(block: MarkdownBlock): ContentBlockTocItem[] {
  const items: ContentBlockTocItem[] = [];
  let headingIndex = 0;

  let match: RegExpExecArray | null;
  while ((match = HEADING_REGEX.exec(block.markdown)) !== null) {
    const [, hashes, textContent] = match;
    items.push({
      id: generateHeadingId(block.id, headingIndex),
      level: hashes.length,
      textContent: stripInlineTokens(textContent),
    });
    headingIndex++;
  }

  // Reset regex lastIndex for next use
  HEADING_REGEX.lastIndex = 0;

  return items;
}

export function extractHeadingsFromBlocks(blocks: ContentBlock[]): ContentBlockTocItem[] {
  const items: ContentBlockTocItem[] = [];

  for (const block of blocks) {
    if (block.type === ContentBlockType.Markdown) {
      items.push(...extractHeadingsFromMarkdownBlock(block));
    } else if (block.type === ContentBlockType.Columns) {
      for (const column of block.columns) {
        items.push(...extractHeadingsFromBlocks(column.content));
      }
    }
  }

  return items;
}
